import React from 'react';
import styled from 'styled-components/macro';

import { palette, breakPoint, classes } from '@mirinae/react-ui';
import { ExternalLinks } from '@mirinae/js-utils';

const SignupBottomWrapper = styled.div`
    position: fixed;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
    inset: 0;
    pointer-events: none;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    padding: 0 29px 20px 23px;
    div {
        pointer-events: all;
        display: flex;
        gap: 30px;
        text-align: center;
        color: ${palette.main.darken[1]};
    }
    p {
        text-align: center;
        color: ${palette.gray[3]};
    }
    
    @media only screen and (max-width: ${breakPoint.sm}) {
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        padding: 0 20px 20px;
        div {
            gap: 20px;
        }
        p {
            margin-top: 10px;
        }
    }
    .${classes.mobile} & {
        position: relative;
        margin-top: 30px;
    }
`;

const SignupBottomMenu = () => {
    return (
        <SignupBottomWrapper>
            <div>
                <a href={ExternalLinks.PrivacyPolicy} target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                </a>
                <a href={ExternalLinks.PrivacyPolicy} target="_blank" rel="noopener noreferrer">
                    Terms and Conditions
                </a>
            </div>
            <p>&copy; Mirinae Technologies Inc.</p>
        </SignupBottomWrapper>
    );
};

export default SignupBottomMenu;